import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const DruhPrijmuSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Zamestnanie',
      value: 'Zamestnanie',
    },
    {
      label: 'Dobrovoľne nezamestnaný',
      value: 'Dobrovoľne nezamestnaný',
    },
    {
      label: 'Práca bez zmluvy (klient nemá oficiálny príjem)',
      value: 'Práca bez zmluvy (klient nemá oficiálny príjem)',
    },
    {
      label: 'Konateľ',
      value: 'Konateľ',
    },
    {
      label: 'SZČO',
      value: 'SZČO',
    },
    {
      label: 'Živnosť v zahraničí',
      value: 'Živnosť v zahraničí',
    },
    {
      label: 'Materská',
      value: 'Materská',
    },
    {
      label: 'Podpora v nezamestnanosti',
      value: 'Podpora v nezamestnanosti',
    },
    {
      label: 'Hmotná núdza',
      value: 'Hmotná núdza',
    },
    {
      label: 'Dohoda',
      value: 'Dohoda',
    },
    {
      label: 'Práca v zahraničí',
      value: 'Práca v zahraničí',
    },
    {
      label: 'Starobný dôchodok',
      value: 'Starobný dôchodok',
    },
    {
      label: 'Invalidný dôchodok',
      value: 'Invalidný dôchodok',
    },
    {
      label: 'Vdovský dôchodok',
      value: 'Vdovský dôchodok',
    },
    {
      label: 'Sirotský dôchodok',
      value: 'Sirotský dôchodok',
    },
    {
      label: 'Výživné',
      value: 'Výživné',
    },
    {
      label: 'Výslužné',
      value: 'Výslužné',
    },
    {
      label: 'Renta',
      value: 'Renta',
    },
    {
      label: 'Príspevky štátu',
      value: 'Príspevky štátu',
    },
    {
      label: 'Iné',
      value: 'Iné',
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default DruhPrijmuSelect;
